import * as store from '@daas-consulting/core-frontend-store';
import { StateToken } from '@ngxs/store';
import { context, feature } from '../remitos.const';
import { RemitosDetailPreviewStateModel as Model } from './remitos-detail_preview.state-model';

const name = store.getName({
  context,
  feature,
  section: store.SectionsNames.detailPreview,
});
export const stateTokenName = new StateToken<Model>(name);
